import { render, staticRenderFns } from "./JobCustomerCard.vue?vue&type=template&id=0a165e2a"
import script from "./JobCustomerCard.vue?vue&type=script&lang=ts"
export * from "./JobCustomerCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports